import { ResourceRole, RESOURCE_ROLES } from "@/constants/CRoles";

export const isSup = (role: ResourceRole, userRole?: string) => {
	if (!role || !userRole) return false;
	return (
		RESOURCE_ROLES.indexOf(role) >=
		RESOURCE_ROLES.indexOf(userRole as ResourceRole)
	);
};
